import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectSwitchTab$ = new BehaviorSubject({});

export const behaviorSubjectSwitchTab = behaviorSubjectSwitchTab$.asObservable();
